<script lang="ts">
  import {replaceValues, t} from '../i18n'
  import type {Collection} from '../types'
  import {user} from '../stores/user'
  import api from '../api/api'
  import {modal} from '../stores/modal'
  import CollectionForm from './CollectionForm.svelte'

  export let collection: Collection

  async function follow() {
    await api.put(`/collections/${collection.id}/follow`)
    collection.is_followed = true
    collection.followers_count += 1
  }

  async function unfollow() {
    await api.put(`/collections/${collection.id}/unfollow`)
    collection.is_followed = false
    collection.followers_count -= 1
  }

  function openEdit(e: Event) {
    e.preventDefault()
    modal.show(CollectionForm, {props: {collection, onSaved: onUpdated}})
  }

  function onUpdated(updatedCollection: Collection) {
    collection = updatedCollection
  }
</script>

<div class="grid__card collection__card">
  <div class="collection__name">
    <a href={`/collections/${collection.handle}`}>{collection.name}</a>

    {#if $user?.id === collection.user_id}
      <a class="edit" onclick={openEdit}>
        {t.collection.edit}
      </a>
    {/if}
  </div>

  <div class="collection__info">
    <span class="collection__poem__count">
      <i class="icon-p-book"></i>
      {replaceValues(t.collection.poems_count, {n: collection.poems_count})}
    </span>

    <span class="collection__status">
      <i class="icon-p-eye"></i>
      {#if collection.public}
        {t.collection.public}
      {:else}
        {t.collection.private}
      {/if}
    </span>
  </div>

  <a class="collection__photo" href={`/collections/${collection.handle}`}>
    <img src={collection.image_url} alt={collection.name}/>
  </a>

  {#if $user && $user.id !== collection.user_id}
    <div class="collection__action">
      {#if !collection.is_followed}
        <span class="collection__btn" onclick={follow}>
          {t.collection.follow_board}
        </span>
      {:else}
        <span class="collection__btn followed" onclick={unfollow}>
          {t.collection.board_followed}
        </span>
      {/if}
    </div>
  {:else}
    <div class="collection__action">
      <span class="follow-board">
        {replaceValues(t.collection.followers_count, {n: collection.followers_count})}
      </span>
    </div>
  {/if}
</div>

<style>
  .collection__btn {
    padding: 10px 20px;
    background: none;
    font-size: 15px;
    width: 100%;
    display: block;
    text-align: center;
    transition: 0.3s ease-in-out;
    -webkit-transition: 0.3s ease-in-out;
    -moz-transition: 0.3s ease-in-out;
    cursor: pointer;
    outline: none;
    border: 1px solid;
  }

  .collection__btn:hover {
    background: #1d1d1f;
    color: #fff;
  }

  .collection__btn.followed {
    border: 1px solid #1d1d1f;
    background: #1d1d1f;
    color: #fff;
  }

  .collection__btn.followed:hover {
    border: 1px solid #1d1d1f;
    color: #1d1d1f;
    background: #fff;
  }

</style>